import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import Confetti from 'react-confetti';

const SuccessConfetti = ({ duration = 3000 }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setShow(false), duration);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  if (!show) {
    return null;
  }

  return <Confetti gravity={0.4} numberOfPieces={400} />;
};

export default SuccessConfetti;

SuccessConfetti.propTypes = {
  duration: PropTypes.number,
};
